import { sendGTMEvent } from "@next/third-parties/google"
import { Attribute } from "api"

export const pageview = (url: string) => {
  sendGTMEvent({
    event: "pageview",
    page: url,
  })
}
export const trackLeadSubmit = (
  type: "שירות לקוחות" | "פזומט",
  subject: string
) => {
  sendGTMEvent({
    event: "lead_submit",
    type,
    subject,
  })
}

export const trackSearchAutocompleteFetch = (
  category: string,
  action: string[] | string,
  label: string = "top_bar",
) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "search_autocomplete",
    category,
    action,
    label,
  })
}

export const trackSearchLocation = (subject: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "search_location",
    subject
  })
}
export const trackSearchBarStations = (text: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "search_bar_stations",
    text
  })
}
export const trackStationsFilter = (attrs: Attribute[]) => {
  const type = attrs.filter(attr => attr.category === "שירותי רכב")
  const category = attrs.filter(attr => attr.category === "yellow")
  const subject = attrs.filter(attr => attr.category === "סופרים")
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "stations_filter",
    type,
    category,
    subject
  })
}
export const trackStationsResetFilter = () => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "stations_reset_filters"
  })
}
export const trackCareerMoreInfo = (jobName: string, companies: string[], date: string, locations: string[]) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "career_more_info",
    type: jobName,
    subject: companies.join(","),
    date: date,
    location: locations.join(",")
  })
}
export const trackCareerShare = (jobName: string, companies: string[], date: string, locations: string[]) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "career_share",
    type: jobName,
    subject: companies.join(","),
    date: date,
    location: locations.join(",")
  })
}
export const trackCareerShareMethodOnMobile = (subject: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "career_share_method",
    subject: subject,
  })
}
export const trackCareerRemoveFilter = (type: string, location: string, category: string, event_name: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: event_name,
    type,
    location,
    category
  })
}
export const trackCareerFreeSearch = (subject: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "career_free_search",
    subject
  })
}
export const trackJobSubmit = (subject: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "career_job_submit",
    subject
  })
}
export const trackJobShare = (category: string, action: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "share job",
    category,
    action,
  })
}
export const trackDownloadFile = (subject?: string, label?: string, category?: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "download file",
    ...(subject && { subject }),
    ...(label && { label }),
    ...(category && { category }),
  })
}
export const trackMapPrint = (subject?: string, label?: string, category?: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "Map_print",
    ...(subject && { subject }),
    ...(label && { label }),
    ...(category && { category }),
  })
}
export const trackMapSearch = (subject: string, search_term: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "Map_search",
    subject,
    search_term,
  })
}
export const trackAreaFilter = (subject: string, category: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "area_filter",
    subject,
    category,
  })
}
export const trackChooseLocationFromList = (subject: string, label: string, category: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "choose_location_from_list",
    subject,
    label,
    category,
  })
}
export const trackChooseLocationFromMap = (subject: string, label: string, category: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "choose_location_from_map",
    subject,
    label,
    category,
  })
}
export const trackLocationInfo = (subject: string, label: string, category: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "location_info",
    subject,
    label,
    category,
  })
}
export const trackWhatsappClick = (subject: string, label: string, category?: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "whatsapp_click",
    subject,
    label,
    ...(category && { category }),
  })
}
export const trackC2CClick = (subject: string, label: string, category?: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "c2c_click",
    subject,
    label,
    ...(category && { category }),
  })
}
export const trackClickOffer = (subject: string, label: string, category: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "click_offer",
    subject,
    label,
    category,
  })
}
export const trackStartForm = (subject: string, label: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "start_form",
    subject,
    label,
  })
}
export const trackSubmitForm = (subject: string, label: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "submit_form",
    subject,
    label,
  })
}
export const trackPresentationDownload = (subject: string, label: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "presetantion_download",
    subject,
    label,
  })
}
export const trackPropertyValuationDownload = (subject: string, label: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "property_valuation_download",
    subject,
    label,
  })
}
export const trackMailClick = (subject: string, label: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "mail_click",
    subject,
    label,
  })
}
export const trackProposalSubmitDownload = (subject: string, label: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "proposal_submit_download",
    subject,
    label,
  })
}
export const trackUploadFileForm = (subject: string, label: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "upload_file_form",
    subject,
    label,
  })
}
export const trackFilterPlatformClick = (subject: string, label: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "filter_platform_click",
    subject,
    label,
  })
}
export const trackCarrouselNavigation = (subject: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "carrousel_navigation",
    subject,
  })
}
export const trackAreaFilterReset = (subject: string) => {
  sendGTMEvent({
    event: "ga4_auto_event",
    event_name: "area_filter",
    subject,
    category: "איפוס",
  })
}
